import styles from '../confirm-email/ConfirmEmail.module.scss'
import React from 'react'
import { useSelector } from 'react-redux'
import { selectUser } from '../../../../app/store/reducers/AuthSlice'
import {
  SendVerificationResponse,
  usePostSiteSendVerificationEmailMutation,
} from '../../../../app/api'
import { showAlert } from '../../../../app/store/reducers/AppSlice'
import { useAppDispatch } from '../../../../app/store/hooks/Redux'
import { IconGmail } from '../../../../shared/components/icons/IconGmail'
import { IconOutlook } from '../../../../shared/components/icons/IconOutlook'
import { Trans, useTranslation } from 'react-i18next'

export const ConfirmEmail = () => {
  const { t } = useTranslation()
  const user = useSelector(selectUser)
  const dispatch = useAppDispatch()

  const [sendVerification] = usePostSiteSendVerificationEmailMutation()

  return (
    <>
      <h2 className={styles.title}>{t('pages.auth.confirmYourEmail')}</h2>
      <p className={styles.subtitle}>
        <Trans i18nKey='pages.auth.weSentToEmail' values={{ email: user.email }}>
          <span className={'font-semibold'} />
        </Trans>
        <br />
        {t('pages.auth.clickToActivate')}
      </p>
      <div className={styles.buttons}>
        <a className={styles.button} href={'https://mail.google.com/mail/u/0/#inbox'}>
          <IconGmail className={'h-[15px] w-fit'} />
          {t('pages.auth.openGmail')}
        </a>
        <a className={styles.button} href={'https://outlook.office.com/mail/'}>
          <IconOutlook className={'h-[15px] w-fit'} />
          {t('pages.auth.openOutlook')}
        </a>
      </div>
      <p>
        {t('pages.auth.cantFindIt')}{' '}
        <button
          className='cursor-pointer text-focus transition-opacity duration-150 hover:opacity-80'
          onClick={() => {
            sendVerification()
              .unwrap()
              .then((response) => {
                if (response.success) {
                  dispatch(
                    showAlert({
                      message: (response as SendVerificationResponse).data?.message ?? '',
                      type: 'success',
                      timeout: 2000,
                    }),
                  )
                }
              })
              .catch(() => undefined)
          }}
        >
          {t('pages.auth.buttons.resend')}
        </button>
      </p>
    </>
  )
}
